import * as Sentry from '@sentry/react';

const dsn = window.ReactAppEnv?.sentry?.dsn;
const isLocalhost = window.location.hostname === 'localhost';
if (dsn && !isLocalhost) {
  Sentry.init({
    dsn,
    environment: window.ReactAppEnv?.sentry?.environment,
    sendDefaultPii: false,
  });
}
